// @flow
import map from 'lodash/map'
import curry from 'lodash/curry'
import type { AppState } from '../../core/types'
import type { EntityState, EntityMap } from './types'

const EMPTY_OBJECT = {}

// root state selector
export const getEntities: AppState => EntityState = curry(
  state => state.entities
)
// get all entities for domain as an object
export const getDomain = curry(function<T>(
  domain: string,
  state: AppState
): EntityMap<T> {
  return getEntities(state)[domain] || EMPTY_OBJECT
})
// get single entity from domain, by its id
export const getById = curry(function(
  domain: string,
  id: string,
  state: AppState
): ?Object {
  return getDomain(domain, state)[id]
})
// get all entities as an array
export const getAll = curry((domain: string, state: AppState): Array<Object> =>
  map(getDomain(domain, state), value => value)
)



// WEBPACK FOOTER //
// ./src/modules/entities/selectors.js